import React from 'react'
import {
  DialogContent,
  DialogContentProps,
  DialogContentRef,
  DialogFooter,
  DialogHeader,
  DialogHeaderProps,
} from './dialog'
import { cn } from '../../lib/utils'
import { Separator, SeparatorProps, SeparatorRef } from './separator'
import { ButtonProps, Button } from './button'

export const DialogContentBrand = React.forwardRef<
  DialogContentRef,
  DialogContentProps
>(({ className, ...props }, ref) => {
  return (
    <DialogContent
      {...props}
      withCloseButton={false}
      className={cn('border-primary p-0 space-y-6', className)}
      ref={ref}
    />
  )
})

export const DialogHeaderBrand = React.forwardRef<
  HTMLDivElement,
  DialogHeaderProps
>(({ className, ...props }, ref) => {
  return (
    <DialogHeader
      {...props}
      className={cn('space-y-4 px-4 pt-4', className)}
      ref={ref}
    />
  )
})

export const DialogButtonGroup = React.forwardRef<
  HTMLDivElement,
  React.HTMLProps<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      {...props}
      ref={ref}
      className={cn(
        'w-full grid grid-cols-2 gap-x-2 [&_button]:hover:bg-transparent overflow-hidden',
        className
      )}
    />
  )
})

export const DialogFooterBrand = React.forwardRef<
  HTMLDivElement,
  React.HTMLProps<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div>
      <DialogSeparatorBrand />
      <DialogFooter
        {...props}
        ref={ref}
        className={cn(
          'w-full !flex !flex-col items-center !justify-center',
          className
        )}
      />
    </div>
  )
})

export const DialogSeparatorBrand = React.forwardRef<
  SeparatorRef,
  SeparatorProps
>(({ className, ...props }, ref) => {
  return (
    <Separator
      {...props}
      ref={ref}
      className={cn(
        'h-2 -mt-2 w-full bg-transparent border-b border-b-primary rounded-bl-md rounded-br-md',
        className
      )}
    />
  )
})

export const DialogButtonActionBrand = React.forwardRef<
  HTMLButtonElement,
  ButtonProps
>(({ className, ...props }, ref) => (
  <Button
    {...props}
    type='submit'
    variant='ghost'
    className={cn('text-primary', className)}
    ref={ref}
  />
))

DialogButtonActionBrand.displayName = 'DialogButtonActionBrand'

export const DialogButtonActionBrandCancel = React.forwardRef<
  HTMLButtonElement,
  ButtonProps
>(({ className, ...props }, ref) => (
  <Button
    className={cn(className)}
    {...props}
    type='button'
    variant='ghost'
    ref={ref}
  />
))

DialogButtonActionBrandCancel.displayName = 'DialogButtonActionBrandCancel'
